import React, { Component } from "react";
import Dashboard from "../Dashboard";
import Accesspage from "../../../common/404";
import PatientList from "./PatientList";
import {NavContext} from '../../../shell/body/propContext'

class DashboardReports extends Component {
  renderbodyLayer() {
    const { slug } = this.props.match.params;
  
    const { menuList } = this.props;
    let obj = null;
    menuList.map((data) => {
      var subData = data.submenu.find((o) => o.route === slug);
      if (subData != undefined) {
        obj = subData;
      }
    });
    var page = null;
    if (obj !== undefined) {
      switch (slug) {
        case "dashboard-details":
          page = <PatientList {...this.props} menuList={menuList} />;
          break;
        default:
          page =
          <NavContext.Consumer>
             {({ setCurrentUnitPlace }) => (
                      <Dashboard {...this.props} menuList={menuList} 
                       setCurrentUnitPlace={setCurrentUnitPlace}
                        />
                    )}
          </NavContext.Consumer>
          break;
      }
    } else if (!obj) {
      switch (slug) {
        case "dashboard-details":
          page = <PatientList {...this.props} menuList={menuList} />;
          break;
        default:
          page = <Dashboard {...this.props} menuList={menuList} />;
          break;
      }
    } else {
      page = <Accesspage></Accesspage>;
    }
    return page;
  }
  render() {
    return <div>{this.renderbodyLayer()}</div>;
  }
}
export default DashboardReports;
